export const testIDs = {
  header: {
    main: 'header',
    logo: {
      main: 'header.logo',
      text: 'header.logo.text',
    },
    versionDropdown: {
      main: 'header.versionDropdown',
      item: 'header.versionDropdown.item',
      emptyItem: 'header.versionDropdown.emptyItem',
      showAllItem: 'header.versionDropdown.moreItem',
    },
    colorModeToggle: 'header.colorModeToggle',
  },
  loadingIndicator: {
    main: 'loadingIndicator',
  },
  contentArea: 'contentArea',
  scrollToTop: 'scrollToTop',
  landingPage: {
    main: 'landingPage',
    projectCategories: {
      main: 'landingPage.projectCategories',
      projectCategory: {
        main: 'landingPage.projectCategories.projectCategory',
        title: 'landingPage.projectCategories.projectCategory.title',
        projects: {
          main: 'landingPage.projectCategories.projectCategory.projects',
          projectCard: {
            main: 'landingPage.projectCategories.projectCategory.projects.projectCard',
            title: 'landingPage.projectCategories.projectCategory.projects.projectCard.title',
            description: 'landingPage.projectCategories.projectCategory.projects.projectCard.description',
            actions: {
              main: 'landingPage.projectCategories.projectCategory.projects.projectCard.actions',
            },
          },
        },
      },
    },
  },
  project: {
    versionOverview: {
      main: 'project.versionOverview',
      majorVersionCard: {
        main: 'project.versionOverview.majorVersionCard',
        versionItem: {
          main: 'project.versionOverview.majorVersionCard.versionItem',
          latestBadge: 'project.versionOverview.majorVersionCard.versionItem.latestBadge',
        },
      },
    },
    documentation: {
      main: 'project.documentation',
      latestVersionWarningBanner: 'project.documentation.latestVersionWarningBanner',
      documentationIframe: 'project.documentation.documentationIframe',
    },
  },
  errorComponent: {
    main: 'errorComponent',
    icon: 'errorComponent.icon',
    title: 'errorComponent.title',
    description: 'errorComponent.description',
    actionButton: 'errorComponent.actionButton',
  },
  plugins: {
    orama: {
      searchButton: 'plugins.orama.searchButton',
      searchBox: 'plugins.orama.searchBox',
    },
    site: {
      main: 'plugins.site',
      title: 'plugins.site.title',
      description: 'plugins.site.description',
      longDescription: 'plugins.site.longDescription',
      featuredProject: 'plugins.site.featuredProject',
    },
    footer: {
      main: 'footer',
      copyright: 'footer.copyright',
      linkGroup: {
        main: 'footer.linkGroup',
        link: {
          main: 'footer.linkGroup.link.main',
        },
      },
    },
  },
} as const

export default testIDs
